import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { LuEye, LuPlus } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';

import StoreCarouselList from './StoreCarouselList';
import StoreCarouselForm from './StoreCarouselForm';
import { StoreCarouselData } from '../../Api/apis/types/carousel.types';
import styles from './StoreCarouselMain.style';

type CarouselView =
  | { step: 'list' }
  | { step: 'add' }
  | { step: 'edit'; carousel: StoreCarouselData };

/** Card shared by the carousel list and the add/edit form */
export default function StoreCarouselMain() {
  const navigate = useNavigate();
  const [view, setView] = useState<CarouselView>({ step: 'list' });
  // The list is dragging rows; leaving now would drop the unsaved order
  const [reordering, setReordering] = useState(false);

  const handleAdd = () => {
    setView({ step: 'add' });
  };

  const handleEdit = (carousel: StoreCarouselData) => {
    setView({ step: 'edit', carousel });
  };
  const handleBackToList = () => {
    setView({ step: 'list' });
  };

  return (
    <div className="bg-white rounded-4 p-4" style={styles.card}>
      {/* Header */}
      <div className="d-flex flex-wrap justify-content-between align-items-start gap-3 pb-3 mb-3 border-bottom">
        <div>
          <h5 className="mb-2" style={styles.pageTitle}>
            Store Carousel
          </h5>
          <p className="mb-0" style={styles.description}>
            Manage the banners shown to shoppers at the top of your
            storefront.
          </p>
        </div>
        <div className="d-flex gap-2">
          <Button
            variant="light"
            size="sm"
            className="border d-flex align-items-center gap-2 px-3"
            onClick={() => navigate('/store-dashboard')}
          >
            <LuEye size={15} /> Preview Carousel
          </Button>
          {view.step === 'list' && (
            <Button
              size="sm"
              className="d-flex align-items-center gap-2 px-3"
              disabled={reordering}
              onClick={handleAdd}
            >
              <LuPlus size={15} /> Add Carousel
            </Button>
          )}
        </div>
      </div>

      {view.step === 'list' ? (
        <StoreCarouselList
          onEdit={handleEdit}
          onReorderingChange={setReordering}
        />
      ) : (
        <StoreCarouselForm
          key={view.step === 'edit' ? view.carousel.id : 'add'}
          carousel={view.step === 'edit' ? view.carousel : undefined}
          onCancel={handleBackToList}
          onSaved={handleBackToList}
        />
      )}
    </div>
  );
}
